import 'react-app-polyfill/ie11';
// import "@babel/polyfill";

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Cookies from 'universal-cookie';
import configureStore from './store';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import App from './containers/App';
import { refreshAuthToken } from './actions/session';
import { fetchProfile, fetchMyAgentProfile, fetchSystemSettingsUrls, fetchPublicSystemSettingsUrls } from './actions/profile';
import { fetchFolders } from './actions/folders';
import { getToken, storeToken } from './utils';

// Initial redux state
const initialReduxState = {
    activity: { feed: {} }
};
export const store = configureStore(initialReduxState);
let accessTokenFromSession = getToken();
const cookies = new Cookies();
const authToken = cookies.get('authDetails');
const urlParams = new URLSearchParams(window.location.search);

// Check if the token is passed in for SSO
if (urlParams.has('token')) {
    // Update the session token
    accessTokenFromSession = urlParams.get('token');
    storeToken(accessTokenFromSession);

    // Remove cookie if it exists
    cookies.remove('authDetails');
}
// Only reload if token doesn't exist in URL
if ((authToken || accessTokenFromSession)) {
    store.dispatch(refreshAuthToken()).then(r => {
        store.dispatch(fetchProfile());
        store.dispatch(fetchMyAgentProfile());
        store.dispatch(fetchFolders());
        store.dispatch(fetchSystemSettingsUrls());
    });
} else {
    store.dispatch(fetchPublicSystemSettingsUrls());
}

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();